import { useMutation, useQueryClient } from '@tanstack/react-query';
import { trackError } from '@proposify/frontend-observability';
import { QueryKeys } from 'utils/queryKeys';
import { linkQueries } from './linkQueries';
import type { ContentLink, FlexDataLink } from './types';

export const useUnlinkCrmObject = (contentId: string) => {
  const queryClient = useQueryClient();
  const queryKey = QueryKeys.getContentFlexDataLinks(contentId);
  const crmVariablesQueryKey = [...QueryKeys.crmVariables, contentId];

  const {
    mutate: unlinkObject,
    isPending,
    isError,
  } = useMutation({
    ...linkQueries.unlink(contentId),
    onSuccess: (_data, obj: FlexDataLink) => {
      queryClient.setQueryData<ContentLink[]>(queryKey, (prev) => (prev ?? []).filter((link) => link.toObject.objectId !== obj.objectId));
      queryClient.invalidateQueries({ queryKey });
      queryClient.invalidateQueries({ queryKey: crmVariablesQueryKey });
    },
    onError: (error: Error) => {
      trackError(error);
      queryClient.invalidateQueries({ queryKey });
    },
  });

  return { unlinkObject, isPending, isError };
};
